import React from 'react'
import './VerticalDivider.css'

export default function VerticalDivider({style}) {
    return (
        <div style={style} className="vertical-divider"></div>
    )
}
